import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('api', 'acao-configuracao-campos');

const parametrizacaoAcaoActions = {
  buscarTemplateMuiltiLiquidacao: { method: 'GET', url: `${basePath}/template-multipla-liquidacao` },
};

export default (resource) => resource(`${basePath}`, {}, parametrizacaoAcaoActions);
